document.addEventListener('DOMContentLoaded', function () {
    const showMore = document.querySelectorAll('.show-more');

    showMore.forEach(el => {
        const elBtn = el.querySelector('.show-more-btn');
    
        elBtn.addEventListener('click', function() {
            const isExpanded = elBtn.getAttribute('aria-expanded') === 'true';
            elBtn.setAttribute('aria-expanded', !isExpanded);
        });
    });
});